import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NotFoundPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
    <main className="max-w-lg w-full text-center space-y-6" id="main-content">
      <p className="text-sm font-semibold text-green-600 tracking-widest">
        404
      </p>
      <h1 className="text-3xl font-bold text-gray-900">
        This page went missing
      </h1>
      <p className="text-gray-600">
        The link you followed may be broken or the page may have been removed.
        Check the URL or head back home.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button asChild className="sm:flex-1">
          <Link to="/">Go home</Link>
        </Button>
        <Button asChild variant="outline" className="sm:flex-1">
          <Link to="/browse">Explore businesses</Link>
        </Button>
      </div>
    </main>
  </div>
);

export default NotFoundPage;
